<template lang="pug">
  Icon.icon(name="notification-play" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Пользователь принял Вашу заявку в
    a(:href="$router.resolve({ name: 'contacts' }).href")  контакты
</template>

<script>
export default {
  name: 'NotificationContactRequestAccepted',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
